import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  caption: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  caption__text: {
    fontSize: 12,
  },
  favorite_button: {
    display: "flex",
    justifyContent: "flex-end",
  },
  image: {
    "$wrapper:hover &": {
      filter: "blur(1px)",
    },
    borderRadius: spacing(1.5),
    display: "block",
    width: "100%",
    height: "auto",
  },
  overlay: {
    "$wrapper:hover &": {
      backgroundColor: "rgba(0,0,0,0.6)",
      opacity: 1,
    },
    borderRadius: spacing(1.5),
    color: "white",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
    left: 0,
    opacity: 0,
    padding: spacing(1),
    position: "absolute",
    top: 0,
    transition: ".2s all ease-out",
    width: "100%",
  },
  text_edit: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  wrapper: {
    borderRadius: spacing(1.5),
    display: "block",
    filter:
      "drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.12)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.2))",
    overflow: "hidden",
  },
}));
